export const itemStatus = {
  "NOT_CHECKED": "尚未盤點",
  "COMPATIBLE": "符合",
  "INCOMPATIBLE": "不符合"
}

export const statusBadge = {
  "尚未盤點": "gray",
  "符合": "green",
  "不符合": "red"
}